<template>

    <div class="animated fadeIn">
        <b-row class="my-3">
            <b-col>
                <h4 class="text-center text-primary">
                    <i class="fa fa-users text-primary mr-2"></i>
                    Gestión de usuarios
                </h4>
            </b-col>
        </b-row>

        <b-row>
            <b-card-body md="12" class="bg-white">
                <b-form class="form-inline align-text-top">

                    <b-col md="3" sm="12">
                        <b-form-group>
                            <multiselect name="selected_headquarters" v-model="search.headquarters" :allow-empty="true"
                                :options="headquarters.map(type => type.uuid)" :multiple="true"
                                :custom-label="opt => headquarters.find(x => x.uuid == opt).name" placeholder="Sedes"
                                selectLabel="+" deselectLabel="-"></multiselect>
                        </b-form-group>
                    </b-col>

                    <b-col md="3">
                        <b-form-group>
                            <multiselect name="selected_departments" v-model="search.departments" :allow-empty="true"
                                :options="departments.map(type => type.uuid)" :multiple="true"
                                :custom-label="opt => departments.find(x => x.uuid == opt).description"
                                placeholder="Departamentos" selectLabel="+" deselectLabel="-"></multiselect>
                        </b-form-group>
                    </b-col>

                    <b-col md="3">
                        <b-form-group>
                            <multiselect name="selected_roles" v-model="search.roles" :allow-empty="true"
                                :options="roles.map(type => type.uuid)" :multiple="true"
                                :custom-label="opt => roles.find(x => x.uuid == opt).description" placeholder="Roles"
                                selectLabel="+" deselectLabel="-"></multiselect>
                        </b-form-group>
                    </b-col>

                    <b-col md="3">
                        <b-button @click="searchQueries" variant="primary" class="px-5 btn btn-pill float-right">
                            Filtrar
                        </b-button>
                    </b-col>

                </b-form>
            </b-card-body>
        </b-row>

        <b-row class="py-2">
            <b-card class="w-100">
                <b-row slot="header" class="m-0 p-0 justify-content-between align-items-center">
                    Usuarios
                    <export-actions :rows="getUsersFilteredData(this.exportRows)" :onClickExportButton="onExportButton">
                    </export-actions>
                </b-row>
                <v-server-table ref="usersTable" class="dataTable" md="12" lg="12" sm="12" :columns="columns"
                    :options="options" :theme="theme">

                    <template slot="uuid" slot-scope="props">
                        <router-link :to="{ path: '/admin/user/edit/' + props.row.uuid }">
                            <i class="fa fa-pencil"></i>
                        </router-link>
                    </template>

                    <template slot="delegation" slot-scope="props">
                        <template v-if="props.row.delegation !== undefined">
                            {{ props.row.delegation.name }}
                        </template>
                    </template>

                    <template slot="department" slot-scope="props">
                        <template v-if="props.row.department !== undefined">
                            {{ props.row.department.description }}
                        </template>
                    </template>

                    <template slot="roles" slot-scope="props">
                        <template v-for="rol in props.row.roles">
                            {{ rol.description }}<br />
                        </template>
                    </template>

                    <template slot="status" slot-scope="props">
                        {{ getStatusByCode(props.row.status) }}
                    </template>

                    <template slot="passwordExpDate" slot-scope="props">
                      {{ moment(props.row.passwordExpDate).format('DD/MM/Y')}}
                    </template>

                </v-server-table>

                <div class="text-right">
                    <b-form-checkbox type="checkbox" v-bind:value="false" v-bind:unchecked-value="true" stacked v-model="search.showBlocked" name="hide">Mostrar bloqueados
                    </b-form-checkbox>
                </div>

            </b-card>
        </b-row>
    </div>
</template>

<script>

import VueNotifications from 'vue-notifications';
import { bus } from '@/helpers/bus';
import Multiselect from 'vue-multiselect';
import Vue from 'vue';
import { ServerTable, Event } from 'vue-tables-2';
import form from '@/helpers/form';
import ExportActions from '@/components/ExportActions';
import { getStatusByCode } from '@/helpers/user-helper';

import { getPaginatedUsers } from '@/api/user-api';
import moment from "moment";

Vue.use(ServerTable)

export default {
    name: 'listUsers',
    components: {
        ServerTable,
        Event,
        Multiselect,
        bus,
        ExportActions
    },
    mounted() {
        this.$eventHub.$emit('captureMenu', this.topmenu);
        this.options.texts = form.tableLabels();

        Event.$on('vue-tables.loading', (data) => {
            this.$_loadingMixin_showLoading();
            this.count = 0;
            this.loading = true;
            //this.$refs.usersTable.data = [];
            if (!!document.querySelector('.VueTables__no-results')) {
                document.querySelector('.VueTables__no-results').style.display = 'none';
            }
            if (!!document.querySelector('.VueTables__row')) {
                document.querySelector('.VueTables__row').style.display = 'none';
            }
            if (document.querySelector('.VueTables__search__input')) {
                this.search.query = null;
                this.$store.commit('SET_USER_TEXT_FILTER', this.search.query)
                data['searchField'] = this.search.query;
            }
        });
        Event.$on('vue-tables.loaded', (data) => {
            if (!!data && !!data.count) {
                this.count = data.count;
            }
            this.$_loadingMixin_hideLoading();
            this.loading = false;
            if (!!document.querySelector('.VueTables__no-results')) {
                document.querySelector('.VueTables__no-results').style.display = 'table-row';
            }
            if (!!document.querySelector('.VueTables__row')) {
                document.querySelector('.VueTables__row').style.display = 'table-row';
            }
        });

        this.getGeneral("departments", "departments");
        this.getGeneral("headquarters", "headquarters");
        this.getGeneral("roles", "roles");
    },
    data: function () {
        return {
            topmenu: [
                {
                    name: 'Inicio',
                    path: '/admin/dashboard',
                    brand: 'fa fa-home'
                },
                {
                    name: 'Nuevo Usuario',
                    path: '/admin/user/add',
                    brand: 'fa fa-user',
                    permissions: ['USER_NEW']
                },
            ],

            items_url: 'users',
            departments: [],
            headquarters: [],
            roles: [],
            items: [],
            totalItems: [],
            hide: false,
            exportRows: [],
            columns: ['uuid', 'username', 'email', 'delegation', 'department', 'roles', 'status', 'passwordExpDate'],
            options: {
                headings: {
                    uuid: {
                        text: '',
                        width: '15px',
                    },
                    username: 'Usuario',
                    email: 'Email',
                    delegation: 'Delegación',
                    department: 'Departamento',
                    roles: 'Rol',
                    status: 'Estado',
                    passwordExpDate: 'Expira en'
                },
                columnsClasses: { uuid: "fit" },
                sortable: ['username', 'email', 'delegation', 'department', 'roles', 'status', 'passwordExpDate'],
                filterable: ['username', 'email', 'delegation', 'roles', 'status'],
                sortIcon: { base: 'fa', up: 'fa-sort-asc', down: 'fa-sort-desc', is: 'fa-sort' },
                texts: null,
                perPageValues: [10, 25, 50, 100],
                pagination: {
                    chunk: 5,
                    edge: true,
                    nav: 'scroll'
                },
                requestFunction: async (data) => {

                    if (this.$store.getters.getFilters[0] !== null) {
                      this.search.headquarters = this.$store.getters.getFilters[0];
                    }
                    if (this.$store.getters.getFilters[1] !== null) {
                      this.search.departments = this.$store.getters.getFilters[1];
                    }
                    if (this.$store.getters.getFilters[2] !== null) {
                      this.search.roles = this.$store.getters.getFilters[2];
                    }
                    if (this.$store.getters.getTextFilter !== null) {
                      data.query = this.$store.getters.getTextFilter;
                    }

                    this.search.query = data.query;
                    this.search.page = data.page;
                    this.search.itemsPerPage = data.limit;
                    let result = await getPaginatedUsers(this.searchData);
                    this.exportRows = result.users;
                    return result;
                },
                responseAdapter: (data) => {
                    return {
                        data: data.users,
                        count: data.count
                    }
                },
            },
            search: {
                page: 1,
                itemsPerPage: 10,
                status: null,
                category: null,
                clientPhone: null,
                headquarters: null,
                departments: null,
                roles: null,
                query: null,
                adviser: null,
                memberCode: null,
                number: null,
                dates: null,
                all: false,
                showBlocked: false
            },
            useVuex: false,
            theme: 'bootstrap4',
            template: 'default',

        }
    },

    computed: {
        searchData() {
            if (process.client) {
              if (document.querySelector('.VueTables__search__input').value === '') {
                this.search.query = null;
                data['searchField'] = this.search.query;
              }
            }
            let data = {
                page: this.search.page,
                itemsPerPage: this.search.itemsPerPage,
                paginated: true,
                showBlocked: this.search.showBlocked,
            };
            if (!!this.search.query && this.search.query !== null && this.search.query !== '') {
              this.$store.commit('SET_USER_TEXT_FILTER', this.search.query)
                data['searchField'] = this.search.query;
            }
            if (this.search.query === '' && this.search.query === undefined) {
              data['searchField'] = null;
              document.querySelector('.VueTables__search__input').value = '';
            }

            if (!!this.search.headquarters && !!this.search.headquarters.length > 0) {
                data['headquartersId'] = this.search.headquarters;
            }

            if (!!this.search.departments && !!this.search.departments.length > 0) {
                data['departmentId'] = this.search.departments;
            }

            if (!!this.search.roles && !!this.search.roles.length > 0) {
                data['rolesId'] = this.search.roles;
            }

            return data;
        },
      searchInput: {
        get: function () {
          return this.$store.getters.getTextFilter;
        },
        set: function (val) {
          this.$store.commit('SET_USER_TEXT_FILTER', val);
          this.$refs.usersTable.refresh();
        }
      }
    },

    methods: {

        searchQueries() {
            let filterData = [];
            filterData.push(this.search.headquarters)
            filterData.push(this.search.departments)
            filterData.push(this.search.roles)
            this.$store.commit('SET_FILTERS_LIST', filterData)
            this.$refs.usersTable.refresh();
        },

        async onExportButton() {
            let exportFilters = this.searchData;
            delete exportFilters.page;
            delete exportFilters.itemsPerPage;
            exportFilters.paginated = false;
            let result = await getPaginatedUsers(exportFilters);
            return this.getUsersFilteredData(result.users);
        },

        async getGeneral(url, varName) {

            let self = this;
            let path = url;

            this.$_loadingMixin_showLoading();

            try {

                const response = await axios.get(path);

                if (response.status == "200") {
                    this[varName] = response.data
                }
            } catch (error) {
                if (error.response.status == 401) {
                    self.showAuthorizedMsg();
                } else {
                    self.showErrorMsg();
                }
            }
            this.$_loadingMixin_hideLoading();

        },
        getUsersFilteredData(rows) {
            return rows ? rows.map(user => ({
                'Usuario': user.username,
                'Email': user.email,
                'Delegación': (user.delegation !== undefined ? user.delegation.name : null),
                'Departamento': (user.department !== undefined ? user.department.description : null),
                'Rol': user.roles.reduce((accumulator, currentUser) => accumulator + currentUser.description + ' ', ''),
                'Estado': getStatusByCode(user.status),
            })) : [];
        },
        getStatusByCode(code) {
            return getStatusByCode(code);
        },
        moment(date) {
          return moment(date).locale("es");
        },
    },
    notifications: {
        showSuccessMsg: {
            type: VueNotifications.types.success,
            title: 'Operación Completada',
            message: 'Registro almacenado con éxito'
        },
        showErrorMsg: {
            type: VueNotifications.types.error,
            title: 'Operación denegada',
            message: 'Algo salió mal'
        },
        showAuthorizedMsg: {
            type: VueNotifications.types.error,
            title: 'Operación denegada',
            message: 'No tiene autorización'
        },
    },
    watch: {
        'search.showBlocked': function () {
            this.$refs.usersTable.refresh();
        },
        'search.query': {
          handler: function(newVal, oldVal) {
            this.search.query = this.searchInput;
            document.querySelector('.VueTables__search__input').value = this.searchInput;
          },
        },
    },
}
</script>
